import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'dashcontent',
    templateUrl: './dashcontent.component.html',
    styleUrls: ['./dashcontent.component.scss'],
})
export class DashContentComponent implements OnInit {
    @Input() public isAdmin;
    @Input() public dashParam;
    @Input() public dashItem;
    
    constructor() {}

    public ngOnInit() {}

    public ngOnDestroy() {}
}
